<template>
  <div class="customer-editor">
    <header-tip>
      信息完整率： {{computeDataFullRate}}%
    </header-tip>
      <el-form :model="form" :rules="rules" ref="form" v-loading="loading">

        <el-row :gutter="0">
          <el-col :span="11">

            <el-form-item label="工作单位" :label-width="width" prop="company" :required="true" error="请输入工作单位">
              <el-input v-model="form.company" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="单位属性" :label-width="width">
              <el-select v-model="form.company_type" placeholder="请选择">
                <el-option v-for="item in companyTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="单位规模" :label-width="width">
              <el-select v-model="form.company_scale" placeholder="请选择">
                <el-option v-for="item in companyScaleList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="单位地址" :label-width="width" prop="company_address" :required="true" error="">
              <el-input v-model="form.company_address" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="职务" :label-width="width">
              <el-select v-model="form.job" placeholder="请选择">
                <el-option v-for="item in jobList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="行业" :label-width="width">
              <el-select v-model="form.industry" placeholder="请选择">
                <el-option v-for="item in industryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

<!--            <el-form-item label="紧急联系人地址" :label-width="width">-->
<!--              <el-input v-model="form.emergency_address" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="业主IC卡" :label-width="width">-->
<!--              <el-input v-model="form.ic_card" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="产权性质" :label-width="width">
              <el-checkbox-group v-model="form.property_type">
                <el-checkbox label="1">产权</el-checkbox>
                <el-checkbox label="2">产权人亲属</el-checkbox>
                <el-checkbox label="3">承租人</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="收房日期" :label-width="width">
              <el-date-picker v-model="form.check_in_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>

            <el-form-item label="转让日期" :label-width="width">
              <el-date-picker v-model="form.transfer_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>

            <el-form-item label="居住享受" :label-width="width">
              <el-radio v-model="form.live_enjoy" label="1">独居</el-radio>
              <el-radio v-model="form.live_enjoy" label="2">夫妇二人</el-radio>
              <el-radio v-model="form.live_enjoy" label="3">夫妇子女</el-radio>
              <el-radio v-model="form.live_enjoy" label="4">和父母同居</el-radio>
              <el-radio v-model="form.live_enjoy" label="5">和子孙同居</el-radio>
            </el-form-item>

            <el-form-item label="电子邮箱" :label-width="width">
              <el-input v-model="form.email" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="个人主页" :label-width="width">
              <el-input v-model="form.website" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="QQ号" :label-width="width">
              <el-input v-model="form.qq" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="微信号" :label-width="width">
              <el-input v-model="form.wechat" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="发票抬头" :label-width="width">
              <el-input v-model="form.invoice_title" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="企业开户行" :label-width="width">
              <el-input v-model="form.invoice_bank" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="企业开户帐号" :label-width="width">
              <el-input v-model="form.invoice_account" autocomplete="off"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="11">

            <el-form-item label="开户银行" :label-width="width">
              <el-select v-model="form.customer_bank" placeholder="请选择或输入开户银行" filterable allow-create>
                <el-option v-for="(item, index) in customerBankList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="开户姓名" :label-width="width">
              <el-input v-model="form.customer_account" autocomplete="off"></el-input>
            </el-form-item>

<!--            <el-form-item label="代扣单位" :label-width="width">-->
<!--              <el-select v-model="form.customer_company" placeholder="请选择">-->
<!--                <el-option v-for="item in customerCompanyList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="工户行代码" :label-width="width">-->
<!--              <el-input v-model="form.customer_bank_code" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="银行卡号" :label-width="width">
              <el-input v-model="form.customer_card_number" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="卡类型" :label-width="width">
              <el-select v-model="form.customer_card_type" placeholder="请选择">
                <el-option label="借记卡" value="1"></el-option>
                <el-option label="存折" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="工户行所在地" :label-width="width">
              <el-input v-model="form.customer_bank_address" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="帐号类型" :label-width="width">
              <el-input v-model="form.customer_account_type" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="客户协议号" :label-width="width">
              <el-input v-model="form.contract_number" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="客户托收编号" :label-width="width">
              <el-input v-model="form.receive_number" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="托收状态" :label-width="width">
              <el-select v-model="form.receive_status" placeholder="请选择">
                <el-option label="未办理" :value="0"></el-option>
                <el-option label="已办理" :value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="需物业关注信息" :label-width="width">
              <el-input v-model="form.focus_info" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="希望接收信息" :label-width="width">
              <el-checkbox-group v-model="form.hope_info">
                <el-checkbox label="1">居家生活类</el-checkbox>
                <el-checkbox label="2">异常天气类</el-checkbox>
                <el-checkbox label="3">节日提醒类</el-checkbox>
                <el-checkbox label="4">安全防范类</el-checkbox>
                <el-checkbox label="5">特别提醒类</el-checkbox>
                <el-checkbox label="6">公共设施设备维护提示类</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="特殊身份" :label-width="width" prop="special" :required="true" error="请选择特殊身份">
              <el-select v-model="form.special" placeholder="请选择">
                <el-option v-for="item in specialList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="附件" :label-width="width" prop="attachment" :required="true" error="请上传资料">
              <el-row>
                <el-col :span="12">
                  <el-link type="primary" @click="$refs.viewFileListRef.UploadFile(data=>{form.attachment=data.FileID},form.attachment)">上传附件</el-link>
                </el-col>
                <el-col :span="12">
                  <el-link type="primary" v-if="form.attachment" @click="$refs.viewFileListRef.show(form.attachment)">查看下载</el-link>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item label="企业税号" :label-width="width">
              <el-input v-model="form.enterprise_fax" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="企业地址" :label-width="width">
              <el-input type="textarea" v-model="form.enterprise_address"></el-input>
            </el-form-item>

            <el-form-item label="企业电话" :label-width="width">
              <el-input v-model="form.enterprise_tel" autocomplete="off"></el-input>
            </el-form-item>

          </el-col>
        </el-row>


      </el-form>
      <div class="editor-footer">
        <el-button @click="visable = false">取 消</el-button>
        <el-button type="primary" v-if="is_edit&&ERP.isPermission(3004001006)" @click="submitForm('form')">确 定</el-button>
      </div>
    <ViewFileList ref="viewFileListRef" />
  </div>
</template>

<script>

  import Common from './common.js'
  import ViewFileList from "../Common/ViewFileList";
  import HeaderTip from "../Common/header-tip";

  export default {
    name: "personal-extend-editor",
    components: {HeaderTip, ViewFileList},
    emits: ['input'],
    props: {
      value: {
        type: Boolean,
        default() {
          return false
        }
      },
      id: {
        type: [Number, String],
        default() {
          return 0
        }
      },
      width: {
        type: String,
        default() {
          return '110px'
        }
      },
      is_edit:{
        type: Boolean,
        default() {
          return true
        }
      }
    },
    data(){
      return{
        visable: this.value,
        loading: false,
        form: this.getFormData({}),
        old_form:this.getFormData({}),
        rules:{
          company: [
            { required: true, message: '请输入工作单位', trigger: 'blur' },
            { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
          ],
          company_address: [
            { required: true, message: '请输入单位地址', trigger: 'blur' },
            { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
          ],
          special: [
            { required: true, message: '请选择特殊身份', trigger: 'blur' }
          ],
          attachment: [
            { required: true, message: '请上传附件', trigger: 'blur' }
          ],
        },
        companyTypeList: [{"value":"1","label":"国有企业"},{"value":"2","label":"集体企业"},{"value":"4","label":"政府机关"},{"value":"5","label":"事业单位"},{"value":"6","label":"外商独资企业"},{"value":"7","label":"中外合资企业"},{"value":"3","label":"私营企业"},{"value":"99","label":"其他"}],
        companyScaleList: [{"value":"1","label":"10人以下"},{"value":"2","label":"10~20人"},{"value":"3","label":"20~50人"},{"value":"4","label":"50人以下"},{"value":"5","label":"100人以下"},{"value":"6","label":"500人以下"},{"value":"7","label":"3000人以下"},{"value":"8","label":"5000人以下"},{"value":"9","label":"5000人以上"},{"value":"10","label":"1万人以上"},{"value":"11","label":"2万人以上"},{"value":"12","label":"3万人以上"}],
        jobList: [{"value":"11","label":"董事长"},{"value":"12","label":"董事"},{"value":"4","label":"执行总经理"},{"value":"14","label":"副总经理"},{"value":"15","label":"总监"},{"value":"5","label":"部门经理"},{"value":"17","label":"主管"},{"value":"6","label":"一般员工"},{"value":"1","label":"厅局级以上"},{"value":"2","label":"处级干部"},{"value":"3","label":"科级干部"},{"value":"22","label":"科员"},{"value":"7","label":"其他"}],
        industryList: [{"value":"1","label":"证券期货"},{"value":"2","label":"运输"},{"value":"3","label":"银行"},{"value":"4","label":"保险"},{"value":"5","label":"传播"},{"value":"6","label":"体育"},{"value":"7","label":"部队"},{"value":"8","label":"邮电通信"},{"value":"9","label":"IT行业"},{"value":"10","label":"商业零售"},{"value":"11","label":"个体经营"},{"value":"12","label":"制造业"},{"value":"13","label":"旅行服务"},{"value":"14","label":"咨询顾问"},{"value":"15","label":"文艺团体"},{"value":"16","label":"房地产"},{"value":"17","label":"酒店餐饮"},{"value":"18","label":"建筑施工"},{"value":"19","label":"科研教育"},{"value":"20","label":"医疗卫生"},{"value":"21","label":"投资贸易"},{"value":"22","label":"政府公务员"},{"value":"23","label":"其它"}],
        customerBankList: ['中国银行','中国工商银行','中国建设银行','中国农业银行','深圳发展银行','广东发展银行','招商银行','杭州商业银行','广州农村商业银行','浙江省农村合作信用社联合社','兴业银行','光大银行','顺德农村商业银行','交通银行','中国邮政储蓄银行','中国银行','中国民生银行','中信银行','华夏银行','南海农村商业银行','佛山农村商业银行股份有限公司'].map(item => {return {value: item, label: item}}),
        customerCompanyList: [{"value":"1","label":"工商银行代扣"},{"value":"2","label":"广州农商银行代扣"},{"value":"3","label":"广州银联代扣"},{"value":"4","label":"光大银行代扣"},{"value":"5","label":"拉卡拉代扣"},{"value":"6","label":"交通银行代扣"},{"value":"7","label":"南海农村商业银行代扣"}],
        specialList: [{"value":99,"label":"非特殊身份"},{"value":1,"label":"地市级政府官员"},{"value":2,"label":"物业管理行业主管领导"},{"value":3,"label":"大型公司/地产公司董事长"},{"value":4,"label":"大型公司/地产公司总裁"},{"value":5,"label":"大型公司/地产公司总经理"},{"value":6,"label":"知名媒体人士"},{"value":7,"label":"影视明星"},{"value":8,"label":"业委会主任/副主任"},{"value":9,"label":"社区主任"},{"value":10,"label":"物业管理行业领导"},{"value":11,"label":"派出所领导"},{"value":12,"label":"一般公司董事长"},{"value":13,"label":"一般公司总裁"},{"value":14,"label":"一般公司总经理"},{"value":15,"label":"地产公司物业对接人"},{"value":16,"label":"业委会成员"},{"value":17,"label":"热心业户"}],
        fileList: [],
        uploadUrl: Common.getBaseUrl() + 'admin/Customer/uploadFile?login_name=' + window.localStorage.getItem('login') + '&token=' + window.localStorage.getItem('token'),
        uploadData: {}
      }
    },
    mounted() {
      console.log('extend mounted')
      console.log(this.$refs.viewFileListRef)
      this.getData()
    },
    watch: {
      value(val) {
      	this.visable = val
      },
      visable(val) {
        this.$emit('input', val)
      },
      id(val) {
        if(this.visable) {
          this.getData()
        }
      }
    },
    methods: {
      getFormData(data) {

        let object = {
          company: '',
          company_type: '',
          company_scale: '',
          company_address: '',
          job: '',
          industry: '',
          emergency_address: '',
          ic_card: '',
          property_type: [],
          check_in_date: '',
          transfer_date: '',
          live_enjoy: '',
          email: '',
          website: '',
          qq: '',
          wechat: '',
          invoice_title: '',
          invoice_bank: '',
          invoice_account: '',
          customer_bank: '',
          customer_account: '',
          customer_company: '',
          customer_bank_code: '',
          customer_card_number: '',
          customer_card_type: '',
          customer_bank_address: '',
          customer_account_type: '',
          contract_number: '',
          receive_number: '',
          receive_status: '',
          focus_info: '',
          hope_info: [],
          special: 99,
          attachment: "",
          enterprise_fax: '',
          enterprise_address: '',
          enterprise_tel: '',
        }

        if(data.id) {

          let newData = Object.assign({}, object, data)

          for(let k in newData) {
            if(newData[k] === null) newData[k] = ''
          }

          // newData.attachment == '' ? newData.attachment = [] : newData.attachment = JSON.parse(newData.attachment)

          if(typeof newData.property_type == 'string') newData.property_type = newData.property_type.split(',')
          if(typeof newData.hope_info == 'string') newData.hope_info = newData.hope_info.split(',')
          // if(typeof newData.attachment == 'string') newData.attachment = newData.attachment.split(',')

          newData.company_type === 0 ? newData.company_type = '' : newData.company_type += ''
          newData.company_scale === 0 ? newData.company_scale = '' : newData.company_scale += ''
          newData.job === 0 ? newData.job = '' : newData.job += ''
          newData.industry === 0 ? newData.industry = '' : newData.industry += ''
          newData.customer_company === 0 ? newData.customer_company = '' : newData.customer_company += ''
          newData.customer_card_type === 0 ? newData.customer_card_type = '' : newData.customer_card_type += ''
          // newData.receive_status === 0 ? newData.receive_status = '' : newData.receive_status += ''
          newData.live_enjoy === 0 ? newData.live_enjoy = '' : newData.live_enjoy += ''

          newData.check_in_date === 0 ? newData.check_in_date = '' : newData.check_in_date = Common.timeFormat(newData.check_in_date)
          newData.transfer_date === 0 ? newData.transfer_date = '' : newData.transfer_date = Common.timeFormat(newData.transfer_date)

          return newData


        } else {

          return Object.assign({}, object, data)

        }
      },
      getData() {

        if(this.id > 0) {
          this.loading = true
          this.$myhttp.get('admin/Customer/getPersonalExtendInfo?customer_id='+this.id).then(backdata => {
            let res = backdata.data
            if(res.code == 200) {
              this.form = this.getFormData(res.data || {customer_id: this.id})
              this.old_form = this.getFormData(res.data || {customer_id: this.id})
            } else {
              this.$message.error('获取客户信息出错！');
            }
            this.loading = false
          })
        } else {
          this.form = this.getFormData({});
          this.old_form = this.getFormData({});
        }

      },
      submitForm(formName) {
        const that=this;
        that.$refs[formName].validate((valid) => {
          if(valid){
            let data = Object.assign({}, that.form)
            data.hope_info = data.hope_info.join(',')
            data.property_type = data.property_type.join(',')

            let old_data = Object.assign({}, that.old_form)
            old_data.hope_info = old_data.hope_info.join(',')
            old_data.property_type = old_data.property_type.join(',')

            if(JSON.stringify(data) === JSON.stringify(old_data)) {
              that.$message.warning('数据未修改，请修改后提交！');
              return false
            }
            data.old_form = JSON.stringify(old_data);

            this.$myhttp.post('admin/Customer/savePersonalExtend', data).then(backdata => {
              let res = backdata.data
              that.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })
              that.$Loading.finish();
            });
          }else {
            that.$message.error('请检查输入项！');
            return false;
          }
        })
      },
    },
    computed:{
      computeDataFullRate(){
        return computeDataFull(this.form)
      }
    }
  }

  const computeDataFull=(obj)=>{
    const required_array =['company','company_address','special','attachment'];
    let complete_num=0;
    let all_num=required_array.length;
    required_array.forEach(item => {
      if (typeof obj[item]==="undefined") {
        return false;
      }
      if(typeof obj[item]==='string'&&obj[item]!==''){
        complete_num++;
      }else if(typeof obj[item]==='number'&&obj[item]!==0){
        complete_num++;
      }else if(typeof obj[item]==='object'&&obj[item]!==null&&Object.keys(obj[item]).length>0){
        complete_num++;
      }
    })
    return (complete_num/all_num*100).toFixed(2)
  }
</script>

<style lang="scss" scoped="scoped">

  @import "./common.scss";

  .line {
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/personal-extend-editor.vue